import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "step-2-include-feature-flag-information-when-capturing-events"
    }}>{`Step 2: Include feature flag information when capturing events`}</h3>
    <p>{`If you want use your feature flag to breakdown or filter events in your `}<a parentName="p" {...{
        "href": "/docs/product-analytics/insights"
      }}>{`insights`}</a>{`, you'll need to include feature flag information in those events.`}</p>
    <p>{`This ensures that the feature flag value is attributed correctly to the event.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` this step is only required for events captured using our server-side SDKs or `}<a parentName="p" {...{
          "href": "/docs/api"
        }}>{`API`}</a>{`.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      